if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector(".quantity__input");
        this.productlist = document.querySelector('.itg-product');
        // if(this.productlist){
        //   this.customAddToCartMobile();
        // }
        this.productThumbHideShow();
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(
          new CustomEvent("product-info:loaded", { bubbles: true })
        );
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html
            .querySelectorAll(".scroll-trigger")
            .forEach((element) =>
              element.classList.add("scroll-trigger--cancel")
            )
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({
        data: { event, target, selectedOptionValues },
      }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage =
          this.dataset.updateUrl === "true" && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage
          ),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl,target),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : "product-info";
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector("head title").innerHTML =
              html.querySelector("head title").innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              html.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector("product-info"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            // document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === "AbortError") {
              console.log("Fetch aborted by user");
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector(
          "variant-selects [data-selected-variant]"
        )?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false
      ) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(",")}`);
        }

        return `${url}?${params.join("&")}`;
      }
      
      updateOptionValues(html,target) {
        const variantSelects = html.querySelector("variant-selects");
      
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(
            this.variantSelectors,
            variantSelects,
            this.preProcessHtmlCallbacks
          );
      
            //PM FUNCTION

          // requestAnimationFrame(() => {
          //   setTimeout(() => {
          //     const variantOptionLabelAll = this.variantSelectors.querySelectorAll('.variant-option-label');
      
          //     for (let i = 0; i < variantOptionLabelAll.length; i++) {
          //       let varInput = variantOptionLabelAll[i].querySelector('input');
          //       let variantAvailability = varInput?.getAttribute('variant-availability');
      
          //       if (varInput?.checked && variantAvailability === 'false') {
          //         console.log('Unavailable input selected:', varInput);
      
          //         // First try: look forward
          //         for (let j = i + 1; j < variantOptionLabelAll.length; j++) {
          //           let nextInput = variantOptionLabelAll[j].querySelector('input');
          //           if (nextInput?.getAttribute('variant-availability') === 'true') {
          //             nextInput.click();
          //             return;
          //           }
          //         }
      
          //         // If not found forward, look backward
          //         for (let j = i - 1; j >= 0; j--) {
          //           let prevInput = variantOptionLabelAll[j].querySelector('input');
          //           if (prevInput?.getAttribute('variant-availability') === 'true') {
          //             prevInput.click();
          //             return;
          //           }
          //         }
      
          //         console.log('No available variant option found to switch to.');
          //         return;
          //       }
          //     }
          //   }, 400);
          // });


            //VG FUNCTION

          // requestAnimationFrame(() => {
          //   setTimeout(() => {
          //     const variantOptionLabelAll = this.variantSelectors.querySelectorAll('.variant-option-label');
          
          //     let isInvalidSelection = false;
          
              
          //     for (let i = 0; i < variantOptionLabelAll.length; i++) {
          //       const input = variantOptionLabelAll[i].querySelector('input');
          //       const isChecked = input?.checked;
          //       const isAvailable = input?.getAttribute('variant-availability') === 'true';
          
          //       if (isChecked && !isAvailable) {
          //         isInvalidSelection = true;
          //         break;
          //       }
          //     }
          
              
          //     if (isInvalidSelection) {
          //       for (let i = 0; i < variantOptionLabelAll.length; i++) {
          //         const input = variantOptionLabelAll[i].querySelector('input');
          //         const isAvailable = input?.getAttribute('variant-availability') === 'true';
          
          //         if (isAvailable) {
          //           input.click();
          //           console.log('First available variant selected:', input);
          //           return;
          //         }
          //       }
          
          //       console.log('No available variant found.');
          //     }
          //   }, 400);
          // });
          
          
          requestAnimationFrame(() => {
            if(document.querySelector(".itg-product")){
            setTimeout(() => {
              const variantOptionLabelAll = this.variantSelectors.querySelectorAll('.variant-option-label');
          
              let hasUnavailableSelected = false;
          
              // Step 1: Check if any unavailable variant is selected
              // for (let i = 0; i < variantOptionLabelAll.length; i++) {
              //   const input = variantOptionLabelAll[i].querySelector('input');
              //   const isChecked = input?.checked;
              //   const isAvailable = input?.getAttribute('variant-availability') === 'true';
          
              //   if (isChecked && !isAvailable) {
              //     hasUnavailableSelected = true;
              //     break;
              //   }
              // }
          
              function varChange(){
                for (let i = 0; i < variantOptionLabelAll.length; i++) {
                  const input = variantOptionLabelAll[i].querySelector('input');
                  const isAvailable = input?.getAttribute('variant-availability') === 'true';
          
                  if (isAvailable) {
                    input.click();
                    return;
                  }
                }
              }

              // Step 2: If any unavailable variant is selected, click the first available one
              // if (hasUnavailableSelected) {
              //   varChange();
              // }else{
                let optIndex = target.dataset.option;
                if(optIndex == '1'){
                  varChange();
                }
              //}
              }, 400);
            }
          });


        }
      }
      
      

      handleUpdateProductInfo(productUrl,target) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          // let variantData = getUpdatedVariantData();
          // let soldOutVariants = variantData.filter(v => v.available === false);
          // console.log("Sold Out Variants:", soldOutVariants);

          // console.log("Updated Variant JSON:", variantData);
          // end custom code

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html,target);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (
            id,
            shouldHide = (source) => false
          ) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(
              `#${id}-${this.dataset.section}`
            );
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle("hidden", shouldHide(source));
            }
          };

          updateSourceFromDestination("price");
          updateSourceFromDestination("Sku", ({ classList }) =>
            classList.contains("hidden")
          );
          updateSourceFromDestination(
            "Inventory",
            ({ innerText }) => innerText === ""
          );
          updateSourceFromDestination("Volume");
          updateSourceFromDestination("Price-Per-Item", ({ classList }) =>
            classList.contains("hidden")
          );

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(
            `#Quantity-Rules-${this.dataset.section}`
          )?.classList.remove("hidden");
          this.querySelector(
            `#Volume-Note-${this.dataset.section}`
          )?.classList.remove("hidden");

          this.productForm?.toggleSubmitButton(
            html
              .getElementById(`ProductSubmitButton-${this.sectionId}`)
              ?.hasAttribute("disabled") ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
          //this.customAddToCartMobile(variant);

          let mediaQuery = window.matchMedia("(min-width: 100px)");

           var swiper = new Swiper(".main_thub_image", {
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
              },
            });
        
            if (swiper) {
              swiper.update();
              swiper.slideTo(0); // Resets to the first slide
            }
          
            if (mediaQuery.matches) { 
              this.productThumbHideShow(variant);
            }
        };
      }

      productThumbHideShow(variant){
          if(variant){
           let optioValue = variant.option1;
            if(optioValue && variant){
              let thumbnail_list = document.querySelectorAll('.thumbnail-list__item');
              const productMediaItems = document.querySelectorAll('.product_media_item');
               thumbnail_list.forEach((thumbnail_item)=>{
                let thumbnailAlt = thumbnail_item.getAttribute('data-img-alt');
                  const isActive = thumbnailAlt === optioValue;
                  thumbnail_item.classList.toggle('product_thumbnail_item_active', isActive);
                });
                
                productMediaItems.forEach((productMedia) => {
                  const mediaAlt = productMedia.getAttribute('data-img-alt');
                  const isActive = mediaAlt === optioValue;
                  
                  productMedia.classList.toggle('product_thumbnail_item_active', isActive);
               });
            }
          }
        }

      // customAddToCartMobile (variant) {
      //   let thisElement = this;
      //   let mainPopup = document.querySelector(".add-cartPopup");
      //   const popupAddToCartButton = document.querySelector(".mobile-add-to-cart__butt");
      //   if(mainPopup && variant){
      //     let varTitle = mainPopup.querySelector(".heading-popup");
      //     let varPrice = mainPopup.querySelector(".addCart-main-price");
      //     let varImg = mainPopup.querySelector(".imageWrp-popup img");
      //     let varCompare = mainPopup.querySelector(".compPrice");
      //     let varWrpPrice = mainPopup.querySelector('.wrapper-price');
      //     let optionFirst = variant.option1;
      //     let optionSecond = variant.option2;
      //     let btnAtcPriceNew;
      //     if (varTitle && varImg) {
      //       varTitle.innerText = variant.name.split("-").slice(0, -1).join("-").trim();
      //       varImg.src = variant.featured_image.src;
      //     }
      //     let varInfoPrice = this.querySelector('.price__container');
          
      //     if(varWrpPrice && varInfoPrice){
      //         varWrpPrice.innerHTML = "";  
      //         varWrpPrice.appendChild(varInfoPrice.cloneNode(true)); 
      //          let vatCartPriceElement = varInfoPrice.querySelector(".price__sale .money");
      //           if (vatCartPriceElement && varPrice) {
                 
      //             varPrice.innerText = vatCartPriceElement.innerText.trim();   
                 
      //           }   
      //       btnAtcPriceNew =vatCartPriceElement.innerHTML?.replace("$",''); 
      //       // console.log("test vatCartPriceElement--->",vatCartPriceElement);
      //       // console.log("test varPrice--->",popupAddToCartButton);
      //     }

      //     if(optionFirst){
      //       const inputElement = mainPopup.querySelector('.product-form__input input[value="'+optionFirst+'"]');
      //       if (inputElement) {
      //         inputElement.checked = true;
      //         inputElement.dispatchEvent(new Event('change'));
      //       }    
      //     }
      //      if(optionSecond){
      //       const inputElement = mainPopup.querySelector('.product-form__input input[value="'+optionSecond+'"]');
      //       if (inputElement) {
      //         inputElement.checked = true;
      //         inputElement.dispatchEvent(new Event('change'));
      //       }
      //     }
          
      //     var getMainPrice = document.querySelector('.main-priceing span.money').textContent;
      //     let priceChange = document.querySelector('.variant-price');
      //     if(priceChange){
      //       priceChange.innerText = ' - '+getMainPrice;
      //     }
          
      //     // console.log(popupAddToCartButton);
      //   if (variant.available === false) {
      //     if (popupAddToCartButton) {
      //       popupAddToCartButton.textContent = "Sold Out";
      //       popupAddToCartButton.disabled = true;
      //       popupAddToCartButton.classList.add("button--disabled");
      //     }
      //   } else {
      //     if (popupAddToCartButton) {
      //       popupAddToCartButton.textContent = `Add to Cart - ${btnAtcPriceNew}` ;
      //       popupAddToCartButton.disabled = false;
      //       popupAddToCartButton.classList.remove("button--disabled");
      //     }
      //   }
      //   }else{
      //     if(popupAddToCartButton){
      //       popupAddToCartButton.addEventListener('click',function(){
      //         let submitButton = thisElement.productForm.querySelector('.product-form__submit');
      //         if(submitButton){
      //           submitButton.click();
      //         }
      //       });
      //     }
      //     if(this.productlist){
      //     let popupElementInput = mainPopup.querySelectorAll('input[type="radio"]');
      //     if(popupElementInput){
      //       popupElementInput.forEach(function(inputElement) {
      //         inputElement.addEventListener('change',function(event) {
      //           event.stopPropagation();
      //           var inputValue = inputElement.value;
      //           const swatchInputElement = thisElement.querySelector('.product-form__input label[data-label-value="'+inputValue+'"]');
      //           if (swatchInputElement) {
      //             const scrollY = window.scrollY;
      //             swatchInputElement.click();
      //             window.scrollTo(0, scrollY);
      //           }
      //         })
      //       })
      //     }
      //   }
      //   }
      // }

      
      updateVariantInputs(variantId) {
       this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          const attributeset = input.getAttribute('data-line-price');
          let priceChange = document.querySelector('.variant-price');
          // if(priceChange){
          //   priceChange.innerText = attributeset;
          // }
          input.value = variantId ?? "";
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
         let metafieldContent = document.querySelectorAll('.model_product');
          if(metafieldContent){
            metafieldContent.forEach((item) => {
              let dataColor = item.getAttribute('data-variant-id');
              let dataColorNumber = Number(dataColor);
              let variantIdNumber = Number(variantId);
                if (!isNaN(dataColorNumber) && dataColorNumber === variantIdNumber) {
                  item.style.display = "flex";
                } else {
              item.style.display = "none";
              }
            });
          }
        this.querySelector("share-button")?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`
        );
        if (this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${url}${variantId ? `?variant=${variantId}` : ""}`
        );

        if(document.querySelector('.popup_input')){
          document.querySelector('.popup_input').value = variantId;
        }
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(
          true,
          window.variantStrings.unavailable
        );

        const selectors = [
          "price",
          "Inventory",
          "Sku",
          "Price-Per-Item",
          "Volume-Note",
          "Volume",
          "Quantity-Rules",
        ]
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(", ");
        document
          .querySelectorAll(selectors)
          .forEach(({ classList }) => classList.add("hidden"));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector("media-gallery ul");
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute("data-zoom-on-hover")) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(
            mediaGallerySource.querySelectorAll("li[data-media-id]")
          );
          const sourceSet = new Set(
            mediaGallerySourceItems.map((item) => item.dataset.mediaId)
          );
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [
              item.dataset.mediaId,
              { item, index },
            ])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] =
            refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll("li[data-media-id]")
          );
          const destinationSet = new Set(
            mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId)
          );
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (
              !sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)
            ) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (
              !destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)
            ) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh)
            [mediaGallerySourceItems, sourceSet, sourceMap] =
              refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach(
            (destinationItem, destinationIndex) => {
              const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

              if (sourceData && sourceData.index !== destinationIndex) {
                mediaGallerySource.insertBefore(
                  sourceData.item,
                  mediaGallerySource.querySelector(
                    `li:nth-of-type(${destinationIndex + 1})`
                  )
                );

                // refresh source now that it has been modified
                [mediaGallerySourceItems, sourceSet, sourceMap] =
                  refreshSourceData();
              }
            }
          );
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(
          `.product-media-modal__content`
        );
        const newModalContent = html.querySelector(
          `product-modal .product-media-modal__content`
        );
        if (modalContent && newModalContent)
          modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity
            ? parseInt(this.quantityInput.dataset.cartQuantity)
            : 0,
          min: this.quantityInput.dataset.min
            ? parseInt(this.quantityInput.dataset.min)
            : 1,
          max: this.quantityInput.dataset.max
            ? parseInt(this.quantityInput.dataset.max)
            : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute("max");
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector(
          ".quantity__rules-cart .loading__spinner"
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() =>
            this.querySelector(
              ".quantity__rules-cart .loading__spinner"
            ).classList.add("hidden")
          );
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector("variant-selects");
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "related-products"
        );
        return document.querySelector(
          `product-recommendations[data-section-id^="${relatedProductsSectionId}"]`
        );
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "quick_order_list"
        );
        return document.querySelector(
          `quick-order-list[data-id^="${quickOrderListSectionId}"]`
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
